import React from "react";
import "./VideoModal.css";

const VideoModal = ({ videoId, isOpen, onClose }) => {
	if (!isOpen) return null;

	return (
		<div className="modal">
			<div className="modal__content">
				<button className="modal__close" onClick={onClose}>
					✕
				</button>
				<div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
					<iframe 
						src="https://player.vimeo.com/video/843714554?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" 
						frameborder="0" 
						allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
						referrerpolicy="strict-origin-when-cross-origin" 
						style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }} 
							title="There (Preview in Post-Production)">
					</iframe>
				</div>
				<script src="https://player.vimeo.com/api/player.js"></script>
			</div>
		</div>
	);
};

{/* <iframe
	width="100%"
	height="100%"
	src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
	title="YouTube video"
	frameBorder="0"
	allow="autoplay; encrypted-media"
	allowFullScreen
></iframe> */}

export default VideoModal;
